export default [
    {
        path: 'terms',
        name: 'terms-and-conditions',
        component: () => import('@/views/terms-conditions/Index'),
        meta: {
            nextable: true
        }
    },
]